import C from '../../../constants';
import PolyUtil from "../../../util/PolyUtil";
import store from 'store';

export const setTenantBillingStatus = (billing) => ({
    type: C.SET_TENANT_BILLING_STATUS,
    payload: billing
});

export const setTenantBillingMethod = (method) => ({
    type: C.SET_TENANT_BILLING_METHOD,
    payload: method
});

export const setTenantBillingHistory = (history) => ({
    type: C.SET_TENANT_BILLING_HISTORY,
    payload: history
});

export const setTenantStripeDetails = (details) => ({
    type: C.SET_TENANT_STRIPE_DETAILS,
    payload: details
});

export const fetchTenantBillingStatus = () => dispatch => {
    if (store.get('type') === 'tenant') return PolyUtil.fetchWrapper('/api/billing/application-fee/check-status/',
        {method: 'GET'}
    ).then((data) => {
        dispatch(setTenantBillingStatus(data));

        return data.payment_method_on_file && PolyUtil.fetchWrapper('/api/billing/payment-method/',
            {method: 'GET'}
        );
    }).then((data) => {
        return dispatch(setTenantBillingMethod(data));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const fetchTenantBillingHistory = (page) => dispatch => {
    return PolyUtil.fetchWrapper('/api/billing/history/?page=' + page,
        {method: 'GET'}
    ).then((data) => {
        return dispatch(setTenantBillingHistory(data));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const fetchTenantStripeDetails = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/billing/application-fee/stripe-details/',
        {method: "GET"}
    ).then((data) => {
        return dispatch(setTenantStripeDetails(data));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const fetchTenantBillingInfo = () => dispatch => {
    return dispatch(fetchTenantBillingStatus())
        .then(() => {
            return dispatch(fetchTenantStripeDetails());
        }).then(() => {
            return fetchTenantBillingHistory(1);
        }).catch((error) => {
            console.log("Error:", error);
        });
};

export const handleAddCard = (token) => dispatch => {
    return PolyUtil.fetchWrapper('/api/billing/payment-method/',
        {
            method: 'PUT',
            body: JSON.stringify({
                stripe_token: token
            })
        }
    ).then(() => {
        return PolyUtil.fetchWrapper('/api/billing/application-fee/check-status/',
            {method: 'GET'}
        );
    }).then((data) => {
        return dispatch(setTenantBillingStatus(data));
    }).then(() => {
        return PolyUtil.fetchWrapper('/api/billing/payment-method/',
            {method: 'GET'}
        );
    }).then((data) => {
        return dispatch(setTenantBillingMethod(data));
    }).catch((error) => {
        console.log("Error: ", error);
        return {"error": {"message": error.error_message !== undefined && error.error_message.split(":", 2).pop()}};
    });
};



// WEBPACK FOOTER //
// ./src/containers/tenant/actions/billing.js